export default __webpack_public_path__ + "static/media/nav_point.468b2ec3.svg";